import { Outlet } from "react-router-dom";
import Drawer from "../components/Drawer";
import { useDrawerContext } from "../context/drawerContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function DrawerWrapper() {
  const { open, setOpen, drawerContent } = useDrawerContext();

  const toggleDrawer = () => {
    setOpen(!open);
  };

  return (
    <>
      <ToastContainer limit={1} />
      <Outlet />
      <div className="relative max-w-full">
        <Drawer isOpen={open} onClose={toggleDrawer}>
          {drawerContent}
        </Drawer>
      </div>
    </>
  );
}
